import { render, staticRenderFns } from "./salesorderfrm.vue?vue&type=template&id=40d8ad2e"
import script from "./salesorderfrm.vue?vue&type=script&lang=js"
export * from "./salesorderfrm.vue?vue&type=script&lang=js"
import style0 from "./salesorderfrm.vue?vue&type=style&index=0&id=40d8ad2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports